import React from 'react';
import classNames from 'classnames';
import catHowellAvatar from './cat-howell-avatar.jpg';

import { LoginType } from '@mm/state/controllers/SessionController';
import { Link } from '@mm/components';

import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';

import css from './AgencyLayout.module.css';
import bgLt from './left_top.svg';
import bgLd from './left_down.svg';
import bgRt from './right_top.svg';
import bgRd from './right_down.svg';
import { Badges } from '../components/Badges/Badges';
import { useAuthBtn } from '../use-auth-btn';

type Props = {
  className?: string;
  children?: any;
};

export const AgencyLayout = ({ className, children }: Props) => {
  const { authBtnText, authLinkDestination, isSignUp } = useAuthBtn(
    LoginType.agency,
  );

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left}>
          <img src={bgLt} className={css.lt} alt="background" />
          <img src={bgLd} className={css.ld} alt="background" />
          <img src={bgRt} className={css.rt} alt="background" />
          <img src={bgRd} className={css.rd} alt="background" />
        </div>
        <div className={css.right} />
      </div>

      <div className={css.container}>
        <div className={css.navbar}>
          <SignUpLogo className={css.logo} />
          <Link className={css.login} to={authLinkDestination}>
            {authBtnText}
          </Link>
        </div>

        <div className={css.content}>
          <div className={css.section}>
            <div className={css.description}>
              <span className={css.headline}>
                Grow your agency by enabling messaging across your client
                portfolio
              </span>

              <span className={css.subtitle}>
                Agencio’s integrated chat marketing hub delivers top ROI for
                clients with less time and resources
              </span>

              <div className={css.testimonial}>
                <div className={css.avatar}>
                  <img src={catHowellAvatar} alt="Cat Howell" />
                </div>
                <div className={css.info}>
                  <span className={css.name}>Cat Howell</span>
                  <span className={css.position}>
                    Founder & CEO Eight Loop Social
                  </span>
                  <span className={css.mark}>“</span>
                  <p className={css.quote}>
                    I am super grateful for the MobileMonkey team because the
                    bot funnels we use at Eight Loop Social effectively segment
                    out our ideal agency clientele. And with templates you can
                    put it into your own accounts and run with it.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={css.section}>
            <div className={css.card}>
              <Badges
                className={classNames(css.badges, {
                  [css.centeredBadges]: !isSignUp,
                })}
                isSignUp={isSignUp}
              />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
